// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quiz-popup-container {
    background-color: #fff;
    border: 5px solid #EDEEFD;
    position: fixed;
    top: 50%;
    left: 50%;
    width: 80vw;
    padding: 100px;
    transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    z-index: 1;
}

.instructions-section h3 {
    font-size: var(--f20);
    font-weight: 700;
    color: var(--dBlue);
    text-align: center !important;
    color: var(--dBlue);
    text-align: center !important;
    padding-bottom: 20px;
}

.quiz-popup-container ul li {
    color: #000;
}

.quiz-popup-container ul li {
    color: #000 !important;
    font-weight: 600 !important;
    margin-bottom: 5px;
}

.answer-section {
    display: flex;
    flex-direction: column;
}

.next-button,
.submit-button,
.close-button {
    background: var(--dPink);
    border: 0;
    outline: 0;
    color: #fff;
    padding: 10px 40px;
    border-radius: 25px;
    margin-top: 40px;
    display: block;

}

button.prev-button {
    background: var(--dBlue);
    border: 0;
    outline: 0;
    color: #fff;
    padding: 10px 40px;
    border-radius: 25px;
    margin-top: 40px;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
}

label.answer-button {
    font-size: var(--pSize);
    font-weight: 700;
    color: var(--dPink);
    margin-top: 10px;
}

.question-text {
    font-size: var(--pSize);
    font-weight: 700;
    color: #000;
    margin-top: 10px;
    margin-bottom: 40px;
}

.button-section {
    display: flex;
    justify-content: space-between;
}

.answer-section input[type="radio"] {
    margin-right: 10px;
}

.close-quiz-btn {
    float: right;
    font-size: 25px;
    cursor: pointer;
}

@media (max-width:565px) {
    .quiz-popup-container {
        width: 100vw;
        padding: 20px;
    }

    .button-section {
        align-items: center;
    }

    button.prev-button,
    .next-button,
    .submit-button,
    .close-button {
        padding: 7px 26px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Quiz/Quiz.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,eAAe;IACf,QAAQ;IACR,SAAS;IACT,WAAW;IACX,cAAc;IAEd,gCAAgC;IAEhC,gCAAgC;IAChC,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;;;IAGI,wBAAwB;IACxB,SAAS;IACT,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;;AAElB;;AAEA;IACI,wBAAwB;IACxB,SAAS;IACT,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,0BAAkB;IAAlB,uBAAkB;IAAlB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;;;;QAII,iBAAiB;IACrB;AACJ","sourcesContent":[".quiz-popup-container {\n    background-color: #fff;\n    border: 5px solid #EDEEFD;\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    width: 80vw;\n    padding: 100px;\n    -webkit-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n    -webkit-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n    z-index: 1;\n}\n\n.instructions-section h3 {\n    font-size: var(--f20);\n    font-weight: 700;\n    color: var(--dBlue);\n    text-align: center !important;\n    color: var(--dBlue);\n    text-align: center !important;\n    padding-bottom: 20px;\n}\n\n.quiz-popup-container ul li {\n    color: #000;\n}\n\n.quiz-popup-container ul li {\n    color: #000 !important;\n    font-weight: 600 !important;\n    margin-bottom: 5px;\n}\n\n.answer-section {\n    display: flex;\n    flex-direction: column;\n}\n\n.next-button,\n.submit-button,\n.close-button {\n    background: var(--dPink);\n    border: 0;\n    outline: 0;\n    color: #fff;\n    padding: 10px 40px;\n    border-radius: 25px;\n    margin-top: 40px;\n    display: block;\n\n}\n\nbutton.prev-button {\n    background: var(--dBlue);\n    border: 0;\n    outline: 0;\n    color: #fff;\n    padding: 10px 40px;\n    border-radius: 25px;\n    margin-top: 40px;\n    width: fit-content;\n}\n\nlabel.answer-button {\n    font-size: var(--pSize);\n    font-weight: 700;\n    color: var(--dPink);\n    margin-top: 10px;\n}\n\n.question-text {\n    font-size: var(--pSize);\n    font-weight: 700;\n    color: #000;\n    margin-top: 10px;\n    margin-bottom: 40px;\n}\n\n.button-section {\n    display: flex;\n    justify-content: space-between;\n}\n\n.answer-section input[type=\"radio\"] {\n    margin-right: 10px;\n}\n\n.close-quiz-btn {\n    float: right;\n    font-size: 25px;\n    cursor: pointer;\n}\n\n@media (max-width:565px) {\n    .quiz-popup-container {\n        width: 100vw;\n        padding: 20px;\n    }\n\n    .button-section {\n        align-items: center;\n    }\n\n    button.prev-button,\n    .next-button,\n    .submit-button,\n    .close-button {\n        padding: 7px 26px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
